export default {
  'EUR': '€',
  'PLN': '"zł'
}
